import { env } from './env';

export const APP_NAME = 'DBNexus';
export const API_BASE_PATH = '/api/v1';
export const API_BASE_URL = env.isDev ? API_BASE_PATH : `${env.dbsBaseUrl}${API_BASE_PATH}`;

// Complete route IDs for navigation
export const ROUTE_IDS = {
  ROOT: '/',
  BLASTS_LIST: '/blasts',
  BLAST_OPTIMISATIONS: '/blasts/$blastName/optimisations',
  BLAST_OPTIMISATION_VIEWER: '/blasts/$blastName/optimisations/$optimiserId',
  BLAST_DESIGN_CONTEXT: '/blasts/$blastName/design_context',
} as const;
